<div class="row">
    <div class="col-xl-4">
        <div class="card mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-warning">Warning</span>
                </div>
                <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-1.jpg"/>
            </div>
            <div class="card-body text-center card-body-avatar">
                <div class="avatar-icon-wrapper border-white overflow-hidden rounded border-3">
                    <div class="avatar-icon rounded-0">
                        <img alt="..." src="assets/images/avatars/avatar4.jpg"/>
                    </div>
                </div>
                <h3 class="font-weight-bold font-size-lg mt-1 mb-2">Zara Wagstaff</h3>
                <p class="text-black-50 mb-0">So how did the classical Latin become so incoherent? According to
                    McClintock, a 15th century typesetter.</p>
                <div class="pt-4">
                    <button class="btn btn-facebook m-1" tooltip="Facebook" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'facebook']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn btn-dribbble m-1" tooltip="Dribbble" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'dribbble']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn btn-twitter m-1" tooltip="Twitter" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'twitter']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges">
                    <span class="badge badge-pill badge-success mr-1">Success</span>
                    <span class="badge badge-pill badge-neutral-info text-info">Info</span>
                </div>
                <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-2.jpg"/>
            </div>
            <div class="card-body card-body-avatar">
                <div class="avatar-icon-wrapper border-white rounded border-2">
                    <div class="avatar-icon rounded">
                        <img alt="..." src="assets/images/avatars/avatar5.jpg"/>
                    </div>
                </div>
                <h3 class="font-weight-bold font-size-lg mt-3 mb-2">Bradleigh Whitmore</h3>
                <p class="text-black-50 mb-0">The 1914 Loeb Edition inspired a graphic designer, it's admittedly an odd
                    way for Cicero to sail into the 21st century.</p>

                <button class="btn btn-success mt-4" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'comment-dots']"></fa-icon>
                    </span>
                    <span class="btn-wrapper--label">Send Message</span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-warning">Warning</span>
                </div>
                <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-3.jpg"/>
            </div>
            <div class="card-body text-center card-body-avatar">
                <div class="avatar-icon-wrapper d-120">
                    <div class="avatar-icon rounded-circle"><img alt="..." class="img-fluid"
                                                                 src="assets/images/avatars/avatar6.jpg"/></div>
                </div>
                <h3 class="font-weight-bold mt-1 mb-3">Bryn Frost</h3>
                <p class="card-text mb-3">Here is the classic lorem ipsum passage followed by Boparai's odd, yet
                    mesmerizing version.</p>
                <div class="pt-3">
                    <button class="btn d-60 p-0 btn-pill btn-github" tooltip="Github" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-xl"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-60 p-0 btn-pill btn-instagram mr-2 ml-2" tooltip="Instagram" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-xl"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-60 p-0 btn-pill btn-google" tooltip="Google" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-xl"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
